// Translations
import landing from '../views/landing/translations/tr'

// Translation: Two-factor authentication (Turkish)
export default Object.freeze({
	name: 'İki faktörlü kimlik doğrulama',
	views: { landing }
})
